module.exports = __webpack_public_path__ + "img/product2.c2bcacdf.png";